import { requestStrapi } from "./global";
/**
 * get all project from API /
 * @param {Number} id projet's id
 * @returns {Promise<project:Object>}
 */

export const loadProject = async (id) => {
  try {
    //let project = await request("/projet/" + id);
    let project = await getProjectBy("slug", id);
    if (!project) return { notFound: true };
    let nextProject = await getProjectBy(
      "id",
      Number(project.id) + 1,
      "image,type"
    );
    if (!nextProject)
      nextProject = (
        await requestStrapi(
          "/projets?&populate=image,types&pagination[pageSize]=1"
        )
      )[0];

    return { project, nextProject, notFound: false };
  } catch (error) {
    return { project: null, nextProject: null, notFound: false };
  }
};

export const loadPathProjects = async () => {
  let projects = await requestStrapi("/projets");
  return projects.map((p) => ({
    params: { id: p.attributes.slug.toString() },
  }));
};

const getProjectBy = async (
  prop,
  value,
  populate = "image,files,languages.icon,softwares.icon,videos.thumbnail,types,seo"
) => {
  return (
    await requestStrapi(
      "/projets?filters[" + prop + "][$eq]=" + value + "&populate=" + populate
    )
  )[0];
};
